<app-header-cartographie screenTitle="Croisement des référentiels" />

<div class="bg-background pb-lg h-[calc(100%-90px)] overflow-x-hidden overflow-y-auto">
  <router-outlet></router-outlet>
</div>
